import { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
export default function LoginCard() {
  const [formData, setFormData] = useState({
    pan: '',
    dob: '',
    otpMethod: '',
    form16: null,
  });
  const navigate = useNavigate();
  const [actionType, setActionType] = useState('');
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    // Convert PAN to uppercase automatically
    const processedValue = name === 'pan' ? value.toUpperCase() : value;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : processedValue,
    }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (actionType === 'otp') {
      if (!formData.pan.trim()) errs.pan = 'PAN is required';
      if (!formData.dob.trim()) errs.dob = 'DOB is required';
      if (!formData.otpMethod) errs.otpMethod = 'Select an OTP method';
    } else if (actionType === 'skip') {
      if (!formData.pan.trim() && !formData.form16) {
        errs.general = 'Either PAN or Form 16 is required to skip OTP';
      }
    }
    return errs;
  };

  const handleSubmit = (type) => {
    setActionType(type);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      toast.error('Please fill required field before proceeding');
      setErrors(validationErrors);
      return;
    }

    if (type === 'otp') {
      if(!formData.pan || !formData.dob || !formData.otpMethod) {
        toast.error('Please fill all required fields');
        return;
      }
      toast.success('OTP sent successfully!');
      navigate('/otp-verification')
    } else {
      toast.success('Skipped OTP');
      navigate('/dashboard')
    }
  };

  return (
    <div className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
    <ToastContainer/>
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source src="./assets/login_video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10" />

      {/* Glass Card */}
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="relative z-20 w-full max-w-2xl rounded-2xl border border-white/30 bg-white/20 backdrop-blur-xl shadow-2xl p-8 md:p-10"
      >
        <h2 className="text-center text-3xl font-bold text-white mb-6">Login</h2>

        <form className="grid grid-cols-1 md:grid-cols-2 gap-6 text-white">
          {/* PAN */}
          <div>
            <label className="block text-sm font-medium mb-1">
              PAN <span className="text-red-400">*</span>
            </label>
            <input
              type="text"
              name="pan"
              value={formData.pan}
              onChange={handleChange}
              placeholder="Enter PAN"
              className={`w-full px-4 py-2 bg-white/20 text-white placeholder-white/70 border rounded-md outline-none focus:ring-2 ${errors.pan ? 'border-red-500' : 'focus:ring-cyan-400 border-white/30'
                }`}
            />
            {errors.pan && <p className="text-red-400 text-sm mt-1">{errors.pan}</p>}
          </div>

          {/* Upload Form 16 */}
          <div>
            <label className="block text-sm font-medium mb-1">Upload Form 16</label>
            <input
              type="file"
              name="form16"
              onChange={handleChange}
              className="w-full text-white bg-white/20 border border-dashed border-white/30 py-2 px-3 rounded-md hover:bg-white/30"
            />
          </div>

          {/* DOB */}
          <div>
            <label className="block text-sm font-medium mb-1">
              DOB <span className="text-red-400">*</span>
            </label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              className={`w-full px-4 py-2 bg-white/20 text-white border rounded-md outline-none focus:ring-2 ${errors.dob ? 'border-red-500' : 'focus:ring-cyan-400 border-white/30'
                }`}
            />
            {errors.dob && <p className="text-red-400 text-sm mt-1">{errors.dob}</p>}
          </div>

          {/* OTP Method */}
          <div>
            <p className="text-sm font-medium mb-2">
              OTP (To add client & get prefilled data)
            </p>
            <div className="flex gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="otpMethod"
                  value="efiling"
                  checked={formData.otpMethod === 'efiling'}
                  onChange={handleChange}
                  className="accent-cyan-400"
                />
                E-filing
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="otpMethod"
                  value="aadhar"
                  checked={formData.otpMethod === 'aadhar'}
                  onChange={handleChange}
                  className="accent-cyan-400"
                />
                Aadhaar
              </label>
            </div>
            {errors.otpMethod && (
              <p className="text-red-400 text-sm mt-1">{errors.otpMethod}</p>
            )}
          </div>

          {/* Buttons */}
          <div>
            <button
              type="button"
              onClick={() => handleSubmit('otp')}
              className="w-full bg-cyan-500 text-white py-2 rounded-md hover:bg-cyan-600 transition-all"
            >
              Send OTP
            </button>
          </div>
          <div>
            <button
              type="button"
              onClick={() => handleSubmit('skip')}
              className="w-full bg-cyan-400 text-white py-2 rounded-md hover:bg-cyan-500 transition-all"
            >
              Skip OTP
            </button>
          </div>
        </form>

        {errors.general && (
          <p className="text-red-400 text-sm mt-4 text-center">{errors.general}</p>
        )}
      </motion.div>
    </div>
  );
}
